import { track } from "@/services/track-custom";
import { firstOpenSupplier, nearestSupplier } from "@/services/nearestSupplier";

/**
 * Por qué sede entró un cliente, y con cuánta información detrás.
 *
 * Hasta ahora esta decisión vivía dentro de `SetLocation`, que era el único
 * sitio por donde se entraba a domicilios. Con la bandera `start_without_address`
 * el linktree entra directo al menú de una sede, así que la decisión la toman
 * dos vistas y no puede seguir siendo un método de una de ellas.
 */
export const trackBranchAssigned = (branch, source, distance) => {
  track.trackEventCluvi(
    {
      supplier_id: branch.id,
      supplier_source: source,
      distance_km:
        distance === null || distance === undefined
          ? null
          : Math.round(distance * 100) / 100
    },
    "set location.branch assigned"
  );
};

/**
 * La sede por la que entra quien no tiene ninguna decidida.
 *
 * Se apuesta por la más cercana a la dirección, calculada en el navegador y sin
 * red —que es justo la condición en la que hace falta—. Sin coordenadas no hay
 * cercanía que calcular y lo único que queda es el orden de la cuenta: eso se
 * registra como `default`, porque no es una apuesta razonable sino la falta de
 * una. Devuelve `null` cuando la cuenta no tiene ninguna sede con domicilio
 * activo, que es una respuesta y no un fallo.
 */
export const nearestBranchEntry = (suppliers, location) => {
  const nearest = nearestSupplier(suppliers, location);
  const branch = nearest ? nearest.supplier : firstOpenSupplier(suppliers);

  if (!branch) return null;

  return {
    branch: branch,
    source: nearest ? "nearest" : "default",
    distance: nearest ? nearest.distance : null
  };
};

/**
 * La sede que la cobertura resolvió, buscada en la configuración de la cuenta.
 *
 * `suppliers_delivery` es la única fuente que trae `slug`, `service_schedule` y
 * `service_take_away` juntos, y los tres hacen falta: el `slug` para navegar y
 * los otros dos para saber qué salidas ofrecer si la sede está cerrada.
 */
export const branchFromCoverage = (suppliers, supplierId) => {
  if (!supplierId) return null;

  return (
    (suppliers || []).find(
      branch => Number(branch.id) === Number(supplierId)
    ) || null
  );
};
